<template>
    <div id="app-header" style="position: sticky; top: 0; z-index: 10">
        <b-navbar toggleable="lg" class="header-bar">
            <b-container class="header-container">
                <div
                    :hidden="this.user && this.user.roles_teacher !== 5"
                    class="d-flex align-items-center"
                >
                    <a-button type="primary" @click="handleToggleCollapsed" :hidden="this.user && this.user.business_id">
                        <a-icon
                            :type="$props.toggleCollapsed ? 'menu-unfold' : 'menu-fold'"
                            class="icon-toggle"
                        />
                    </a-button>
                    <!--          <img :src="logo_student" class="logo-student" alt="" />-->
                    <div>
                <span v-if="this.user && this.user.business_id">
                    <!-- 213 for sangsang -->
                    <img v-if="this.user.business_id == 213" src="https://sangsang.com.vn/images/sangsang/LogoSangSang.png" class="logo-student" alt="" style="margin-left: 0px;">
                    <img v-else src="https://www.masterkorean.vn/images/logo.png" class="logo-student" alt="">
                </span>
                        <span v-else>
                    <img src="https://www.masterkorean.vn/images/logo.png" class="logo-student" alt="">
                </span>
                    </div>

                </div>
                <div></div>

                <div id="nav-collapse" class="">
                    <b-navbar-nav class="align-items-right flex-row justify-content-end">
                        <div>
                            <img
                                v-if="locale == 'vi'"
                                src="https://img.icons8.com/color/40/000000/vietnam.png"
                            />
                            <img
                                v-if="locale == 'kr'"
                                src="https://img.icons8.com/color/40/000000/south-korea.png"
                            />
                        </div>
                        <b-nav-item-dropdown class="language-switch" :text="locale" right>
                            <b-dropdown-item
                                @click="changeLocale(locale)"
                                v-for="(locale, index) in locales"
                                :key="index"
                            >
                                {{ $t("commons.label." + locale.text) }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                        <div
                            class="cart-btn-container"
                            v-b-tooltip.hover
                            title="Go To Cart"
                            v-if="roleUser == 5 && !isBusinessStudent()"
                            @click="handleClickToCart(`/student/exam/my-cart`)"
                        >
                            <ion-icon name="cart-outline" style="color:green"></ion-icon>
                            <div class="number-in-cart-badge-container">
                                <div class="number-in-cart-badge">
                                    {{ this.numberExamInCart ? this.numberExamInCart.length : 0 }}
                                </div>
                            </div>
                        </div>
                        <div class="user-container" v-b-modal.headerUser>
                            <p class="username" v-if="roleUser !== 5">{{ user.user_name }}</p>
                            <b-icon-person-circle></b-icon-person-circle>
                            <ion-icon
                                name="chevron-down-outline"
                                class="pl-2"
                                v-if="roleUser !== 5"
                            />
                        </div>
                    </b-navbar-nav>
                </div>
            </b-container>
        </b-navbar>
        <b-modal id="headerUser" class="" hide-footer hide-header size="sm">
            <div
                class="d-flex align-items-center justify-content-center logout-button p-2"
                v-if="roleUser === 5"
            >
                <p class="username">{{ user.user_name }}</p>
            </div>
            <div
                class="d-flex align-items-center justify-content-center logout-button p-2"
                v-b-modal.modal-logout
                @click="popupLogoutClick()"
            >
                <ion-icon name="power-sharp" class=""></ion-icon>
                <p>{{ $t("commons.button.logout") }}</p>
            </div>
            <div
                class="resetPass-button d-flex align-items-center justify-content-center p-2"
                @click="changePasswordClick()"
                v-b-modal.modal-changePassword
                v-if="roleUser !== 5"
            >
                <p>{{ $t("resetPassword.label.change_password") }}</p>
            </div>
        </b-modal>
        <b-modal
            id="modal-changePassword"
            hide-footer
            hide-header
            class="popup-change-password"
            ref="my-modal-change-password"
        >
            <p class="title-change-password">
                {{ $t("resetPassword.label.change_password") }}
            </p>
            <ValidationObserver ref="observer">
                <b-form>
                    <p class="required title-item-password">
                        {{ $t("commons.message.current_password") }}
                    </p>
                    <ValidationProvider
                        :rules="{ required: true, min: 6, max: 50 }"
                        :name="$t('msg.E_UC1_42')"
                    >
                        <b-form-group
                            slot-scope="{ valid, errors }"
                            label=""
                            class="passInput"
                        >
                            <b-form-input
                                :type="passwordType"
                                class="custom-input"
                                required
                                maxlength="50"
                                v-model="paramsResetPassword.currentPassword"
                            >
                            </b-form-input>
                            <div @click="switchVisibility()" class="hide-password">
                                <ion-icon
                                    v-if="eyeHide"
                                    name="eye-outline"
                                    class="icon-eye-login"
                                ></ion-icon>
                                <ion-icon
                                    v-if="eyeShow"
                                    name="eye-off-outline"
                                    class="icon-eye-login"
                                ></ion-icon>
                            </div>
                            <!-- <b-form-invalid-feedback>
                                          {{ errors[0] }}
                                        </b-form-invalid-feedback> -->
                            <span class="text-danger">
                {{ errors[0] ? $t("msg.E_UC1_42") : null }}
              </span>
                        </b-form-group>
                    </ValidationProvider>
                    <p class="required title-item-password">
                        {{ $t("commons.message.new_password") }}
                    </p>
                    <ValidationProvider
                        :rules="{ required: true, min: 6, max: 50 }"
                        :name="$t('commons.message.new_password')"
                    >
                        <b-form-group
                            slot-scope="{ valid, errors }"
                            label=""
                            class="passInput"
                        >
                            <b-form-input
                                :type="showNewPassword"
                                class="custom-input"
                                required
                                min="6"
                                maxlength="50"
                                v-model="paramsResetPassword.newPassword"
                            >
                            </b-form-input>
                            <div @click="changeNewPassword()" class="hide-password">
                                <ion-icon
                                    v-if="hideNotiNewPassword"
                                    name="eye-outline"
                                    class="icon-eye-login"
                                ></ion-icon>
                                <ion-icon
                                    v-if="showNotiNewPassword"
                                    name="eye-off-outline"
                                    class="icon-eye-login"
                                ></ion-icon>
                            </div>
                            <!-- <b-form-invalid-feedback>
                                          {{ errors[0] }}
                                        </b-form-invalid-feedback> -->
                            <span class="text-danger">
                {{ errors[0] ? $t("msg.E_UC1_33") : null }}
              </span>
                        </b-form-group>
                    </ValidationProvider>
                    <p class="required title-item-password">
                        {{ $t("commons.message.confirm_password") }}
                    </p>
                    <ValidationProvider
                        :rules="{ required: true, min: 6, max: 50 }"
                        :name="$t('commons.message.confirm_password')"
                    >
                        <b-form-group
                            slot-scope="{ valid, errors }"
                            label=""
                            class="passInput"
                        >
                            <b-form-input
                                :type="showConfirmPassword"
                                class="custom-input"
                                maxlength="50"
                                v-model="paramsResetPassword.confirmPassword"
                            >
                            </b-form-input>
                            <div @click="changeConfirmPassword()" class="hide-password">
                                <ion-icon
                                    v-if="hideNotiConfirmPassword"
                                    name="eye-outline"
                                    class="icon-eye-login"
                                ></ion-icon>
                                <ion-icon
                                    v-if="showNotiConfirmPassword"
                                    name="eye-off-outline"
                                    class="icon-eye-login"
                                ></ion-icon>
                            </div>
                            <!-- <b-form-invalid-feedback>
                                          {{ errors[0] }}
                                        </b-form-invalid-feedback> -->
                            <span class="text-danger">
                {{ errors[0] ? $t("msg.E_UC1_33") : null }}
              </span>
                        </b-form-group>
                    </ValidationProvider>
                </b-form>
            </ValidationObserver>
            <div class="button-change-password">
                <div class="group-button">
                    <button
                        type="button"
                        class="btn btn-cancel-changepassword"
                        @click="hideChangePassword()"
                    >
                        {{ $t("resetPassword.label.cancel") }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-save-changepassword"
                        @click="resetPassword()"
                    >
                        {{ $t("resetPassword.label.save") }}
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal
            id="modal-logout"
            class="log-out-popup"
            v-if="popupLogout"
            hide-footer
        >
            <template #modal-header="{ close }" class="main-logout">
                <p class="title-logout">{{ $t("resetPassword.label.logout") }}</p>
            </template>
            <div class="modal-main">
                <p class="detail-logout">
                    {{ $t("resetPassword.label.logout_confirm") }}
                </p>
                <div class="logout-aceept">
                    <div class="cancel-logout" @click="popupLogoutClick()">
                        <p>{{ $t("resetPassword.label.cancel") }}</p>
                    </div>
                    <div class="confirm" @click="logout()">
                        <p>{{ $t("resetPassword.label.confirm") }}</p>
                    </div>
                </div>
            </div>
            <!-- </div> -->
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { notification } from "ant-design-vue";
import Cookies from "js-cookie";

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    name: "app-header",
    props: ["toggleCollapsed"],
    setup() {
        const openNotificationWithIcon = (type, message, description) => {
            notification[type]({
                message: message,
                description: description
            });
        };

        return {
            openNotificationWithIcon
        };
    },
    data() {
        return {
            roleUser: null,
            passwordType: "password",
            showNewPassword: "password",
            showConfirmPassword: "password",
            eyeHide: false,
            eyeShow: true,
            hideNotiNewPassword: false,
            showNotiNewPassword: true,
            hideNotiConfirmPassword: false,
            showNotiConfirmPassword: true,
            authorHeader: false,
            changePassword: false,
            popupLogout: false,
            paramsResetPassword: {
                id: null,
                currentPassword: null,
                newPassword: null,
                confirmPassword: null
            },
            logo_student: null
        };
    },
    computed: {
        ...mapGetters({
            locales: "lang/locales",
            locale: "lang/locale",
            isLogin: "auth/isLogin",
            permissions: "auth/permissions",
            token: "auth/token",
            user: "auth/user",
            newPassword: "auth/newPassword",
            numberExamInCart: "exam/examInCart",
            logoStudent: "auth/logo"
        })
        // navItems() {
        //   return NAVBAR_ITEMS.filter(item => {
        //     return (
        //       this.permissions.includes(item.permission) && item.isShow == "true"
        //     );
        //   });
        // }
    },
    async created() {
        this.roleUser = this.user.roles_teacher;
        this.logo_student = this.logoStudent;
        if (this.user.roles_teacher === 5) {
            await this.$store.dispatch("exam/getExamInCart", this.user.id);
        }
    },
    methods: {
        handleClickToCart(path) {
            window.location.pathname = path;
        },
        isBusinessStudent() {
            const typeOfBusinessId = typeof this.user.business_id;
            return typeOfBusinessId === "number";
        },
        cancel() {},
        showModal() {
            this.$refs["my-modal"].show();
        },
        toggleModal() {
            this.$refs["my-modal"].hide();
        },

        hideChangePassword() {
            this.$refs["my-modal-change-password"].hide();
        },
        switchVisibility() {
            if (this.passwordType === "text") {
                this.passwordType = "password";
                this.eyeShow = true;
                this.eyeHide = false;
            } else if (this.passwordType === "password") {
                this.passwordType = "text";
                this.eyeShow = false;
                this.eyeHide = true;
            }
        },
        changeNewPassword() {
            if (this.showNewPassword === "text") {
                this.showNewPassword = "password";
                this.showNotiNewPassword = true;
                this.hideNotiNewPassword = false;
            } else if (this.showNewPassword === "password") {
                this.showNewPassword = "text";
                this.showNotiNewPassword = false;
                this.hideNotiNewPassword = true;
            }
        },
        changeConfirmPassword() {
            if (this.showConfirmPassword === "text") {
                this.showConfirmPassword = "password";
                this.showNotiConfirmPassword = true;
                this.hideNotiConfirmPassword = false;
            } else if (this.showConfirmPassword === "password") {
                this.showConfirmPassword = "text";
                this.showNotiConfirmPassword = false;
                this.hideNotiConfirmPassword = true;
            }
        },
        changePasswordClick() {
            this.paramsResetPassword.id = this.user.id;
            this.changePassword = !this.changePassword;
        },
        popupLogoutClick() {
            this.popupLogout = !this.popupLogout;
        },
        handleToggleCollapsed() {
            this.$emit("toggle-collapsed");
        },
        showAuthor() {
            this.authorHeader = !this.authorHeader;
        },
        async changeLocale(locale) {
            this.$loadMessages(locale.target);
            this.$root.loadLocale(locale.target);
            this.$store.dispatch("lang/changeLocale", locale);
        },
        async logout() {
            const params = {};
            await this.$store.dispatch("auth/logout", params);
            (await Cookies.get("student-permissions")) === "student"
                ? await this.$router.push({ name: "LoginStudent" })
                : await this.$router.push({ name: "Login" });
        },
        async resetPassword() {
            this.paramsResetPassword.id = this.user.id;
            var currentPassword = this.paramsResetPassword.currentPassword;
            var newPassword = this.paramsResetPassword.newPassword;
            var confirmPassword = this.paramsResetPassword.confirmPassword;
            const params = {
                id: this.user.id,
                current_password: this.paramsResetPassword.currentPassword,
                password: this.paramsResetPassword.newPassword,
                confirm_password: this.paramsResetPassword.confirmPassword
            };

            if (
                currentPassword.length < 6 ||
                newPassword.length < 6 ||
                confirmPassword.length < 6
            ) {
                return;
            }

            if (
                currentPassword == null &&
                newPassword == null &&
                confirmPassword == null
            ) {
                this.$root.toast(
                    this.$t("resetPassword.message.match_password_fail"),
                    "danger",
                    this.$t("resetPassword.message.validate_field")
                );
                return;
            }

            await this.$store.dispatch("auth/resetPassword", params);
            if (this.newPassword.message == "password not match") {
                this.$root.toast(
                    this.$t("resetPassword.label.noti_error"),
                    "danger",
                    this.$t("commons.message.wrong_change_password")
                );
                return;
            }

            if (confirmPassword !== newPassword) {
                this.$root.toast(
                    this.$t("resetPassword.label.noti_error"),
                    "danger",
                    this.$t("resetPassword.message.password_not_match")
                );
                return;
            }

            if (currentPassword === newPassword) {
                this.$root.toast(
                    this.$t("resetPassword.message.match_password_fail"),
                    "danger",
                    this.$t("resetPassword.message.match_password")
                );
                return;
            }

            if (this.newPassword.status == 200) {
                this.$root.toast(
                    "Reset Password",
                    "success",
                    this.$t("resetPassword.label.noti_success")
                );
                this.$router.push({ name: "Login" });
                return;
            } else {
                this.$root.toast(
                    "Reset Password",
                    "danger",
                    this.$t("resetPassword.label.noti_error")
                );
            }
        }
    }
};
</script>

<style lang="scss">
#headerUser___BV_modal_backdrop_ {
    background-color: transparent;
}

#headerUser___BV_modal_content_ {
    width: 150px;
}

#headerUser___BV_modal_body_ {
    padding: 0px;
    display: flex;
    align-items: center;
    flex-direction: column;
}

.custom-input {
    height: 49px;
}

.popup-change-password {
    margin-top: 100px;
}

#headerUser {
    top: 2% !important;
    left: -2% !important;
    width: 200% !important;
}

.button-change-password {
    padding: 10px 0;
}

.logout-button,
.resetPass-button {
    width: 100%;
}

.logout-button:hover,
.resetPass-button:hover {
    background: #f2f0f9;
}

.logout-button ion-icon {
    padding-top: 3px;
    font-size: 20px;
    padding-right: 15px;
}

p {
    margin-bottom: 0px !important;
}

.user {
    .dropdown-toggle::after {
        display: none;
    }
}

.header-bar {
    background-color: white;
    color: black;
    //position:fixed;
    top: 0;
    //left: 193px;
    //width: calc(100% - 193px);
    //z-index: 999;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
}

.user-container {
    padding: 0.5rem 1rem;
    font-size: 16px;
    display: flex;
    align-items: center;
}

.username {
    margin-right: 10px;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.header-container {
    margin-right: 0;
    font-size: 23px;
}

.header-container.container {
    max-width: 100% !important;
    flex-direction: row !important;
    margin-bottom: 0 !important;
}

.form-change-password {
    height: 10px;
}

.log-out,
.change_password {
    height: 40%;
    width: 100%;
}

.log-out:hover,
.change_password:hover {
    background: #f2f0f9;
    cursor: pointer;
}

.main1 {
    width: 100%;
    height: 100%;
}

.log-out-text,
.log-out-change_password {
    height: 100%;
    width: 100%;
    display: flex;
    position: relative;
    // margin-left:5%;
}

.icon-logout {
    // position: absolute;
    // padding:1px;
    font-size: 24px;
    margin-left: -19%;
    margin-right: 8%;
    color: #008f00;
    // font-weight:800;
}

.log-out-text,
.log-out-change_password p {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 16px;
    color: #000000;
}

.popup-changepass {
    background-color: #ffffff;
    width: 23%;
    height: 429px;
    position: absolute;
    // position: relative;
    z-index: 2;
    box-shadow: 4px rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    margin-left: 30%;
    margin-top: 10%;
}

.icon-changepassword {
    margin-left: 89%;
    margin-top: 3%;
    font-size: 23px;
}

.popup-main {
    width: 80%;
    height: 85%;
    margin-left: 10%;
    margin-top: 1.5%;
}

.title {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 26px;
    line-height: 150%;
    color: #3182ce;
    text-align: center;
}

.main-change {
    height: 57%;
    margin-top: 3%;
}

.main-change .main-input {
    height: 36.16%;
    width: 100%;
    position: relative;
}

.input-currentPassword {
    position: relative;
    width: 100%;
    height: 100%;
}

.passInput {
    position: relative;
}

.hide-password {
    position: absolute;
    top: 18%;
    right: 1%;
    border: none;
    background: white;
    font-size: 22px;
    text-align: center;
}

.main-input p {
    // font-family: Inter;
    font-family: sans-serif;
    font-style: normal;
    // font-weight: 600;
    font-size: 18px;
    line-height: 150%;
    color: #000000;
}

.main-input input {
    background: #ffffff;
    border: none;
    border-radius: 3px;
    height: 52%;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    width: 100%;
}

.accept {
    width: 100%;
    height: 12%;
    display: flex;
}

.accept .cancel,
.accept .save {
    border-radius: 3px;
    width: 27%;
    height: 100%;
}

.accept .cancel p,
.accept .save p {
    // font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 16px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.accept .cancel {
    background: #f61717;
    margin-left: 44%;
}

.accept .save {
    background: #3182ce;
    margin-left: 2%;
}

.log-out-popup {
    position: absolute;
    z-index: 3;
    height: 107%;
    width: 100px;
    // top:1000px;
    // margin-top:
    background: #e5eaff;
}

.main-logout {
    width: 25.8%;
    height: 31%;
    background: #ffffff;
    box-shadow: 0px 8px 26px 1px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    margin-left: 30%;
    margin-top: 12%;
    padding: 1.7% 2%;
    text-align: center;
}

.title-logout {
    font-style: normal;
    font-weight: 640;
    font-size: 28px;
    line-height: 19px;
    color: #211c1b;
    padding: 12px 0;
}

.title-item-password {
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 150%;
    color: #000000;
}

.title-change-password {
    font-family: Inter;
    font-style: normal;
    font-weight: 700;
    font-size: 31px;
    line-height: 150%;
    color: #3182ce;
    width: 100%;
    text-align: center;
}

.detail-logout {
    // font-family: 'Roboto';
    font-style: normal;
    font-weight: 440;
    font-size: 17px;
    line-height: 14px;
    color: #000000;
    // margin-top:7%;
}

.modal-main {
    height: 168px;
    position: relative;
    // margin-top: 100px ;
}

.logout-aceept {
    height: 41px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0;
    bottom: 0;
    float: right;
}

.cancel-logout,
.confirm {
    height: 100%;
    width: 20%;
    border-radius: 3px;
    // margin-top:29%;
    cursor: pointer;
}

.cancel-logout p,
.confirm p {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
}

.cancel-logout {
    background: #f61717;
    // margin-left:57%;
}

.confirm {
    margin-left: 3%;
    background: #3182ce;
}

.form-reset {
    width: 100%;
    height: 100%;
}

.layout {
    position: absolute;
    z-index: 1;
    background: black;
    color: black;
    opacity: 0.4;
    width: 100%;
    height: 100%;
}

.header-logout {
    display: flex;
    position: relative;
}

.header-logout .icon-exit {
    font-size: 24px;
    position: absolute;
    right: 0;
}

.margin-eye {
    margin-left: -36%;
}

.group-button {
    display: flex;
    justify-content: flex-end;
}

.btn-cancel-changepassword,
.btn-save-changepassword {
    font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
    width: 19%;
    height: 2.6rem;
    margin-left: 2%;
}

.btn-cancel-changepassword {
    background: #f61717;
    border-radius: 3px;
}

.btn-save-changepassword {
    background: #3182ce;
    border-radius: 3px;
}

.icon-toggle.anticon,
.icon-toggle.anticon-menu-fold {
    vertical-align: 0 !important;
}

@media only screen and (min-width: 47.189rem) and (max-width: 85rem) {
    .popup-changepass {
        width: 31%;
    }
}

@media only screen and (max-width: 47.188rem) {
    .popup-changepass {
        width: 300px;
    }
}

.language-switch {
    font-size: 16px;
    text-transform: uppercase;
}

.language-switch b-dropdown-item {
    font-size: 16px;
}

.hung {
    position: relative;
}

.cart-btn-container {
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    background-color: white;
    border-radius: 5px;
    cursor: pointer;
    font-size: 28px;
}

.cart-btn-container:hover {
    background: #f2f0f9;
}

.number-in-cart-badge-container {
    position: absolute;
    height: 15px;
    width: 15px;
    font-size: 0.4em;
    border-radius: 100%;
    background: #dc3545;
    color: whitesmoke;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    margin-left: 30px;
}

.number-in-cart-badge {
    margin-bottom: 1px;
}

.logo-student {
    margin-left: 20px;
    //   width: 70px;
    height: 40px;
}

a.my-exam-header-student {
    color: black;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
}

.ant-btn{
    height: auto !important;
    padding: 5px 10px !important;

}
.ant-btn i{
    font-size: 25px;
    display: flex !important;
}

@media (min-width: 992px) {
    .navbar-expand-lg .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
        justify-content: flex-end;
    }
}

@media (max-width: 992px) {
    #headerUser___BV_modal_content_ {
        margin-top: 35px;
        margin-left: 30px;
    }

    .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-lg .navbar-collapse {
        margin-top: 10px;
    }

    button:focus {
        outline: none;
    }
}
</style>
